/**
 * Dependencies
 */
import http from '../../../services/HttpService.js'

/** @function
 *  @actions for map component in Digital OM
 */
const addPoint = ({commit}, payload) => commit('ADD_POINT', payload)
const removePoint = ({commit}, payload) => commit('REMOVE_POINT', payload)
const focusPoint = ({commit}, payload) => commit('FOCUS_POINT', payload)

/** @function
 *  @actions for text component in Digital OM
 */
const addText = ({commit}, payload) => commit('ADD_TEXT', payload)
const deleteText = ({commit}, payload) => commit('DELETE_TEXT', payload)

/** @function
 *  @actions for table component in Digital OM
 */
const updateTableData = ({commit}, payload) => commit('UPDATE_TABLE_DATA', payload)
const updateTableHeader = ({commit}, payload) => commit('UPDATE_TABLE_HEADER', payload)
const addTableRow = ({commit}, payload) => commit('ADD_TABLE_ROW', payload)
const addTableColumn = ({commit}, payload) => commit('ADD_TABLE_COLUMN', payload)
const removeTableRow = ({commit}, payload) => commit('REMOVE_TABLE_ROW', payload)
const removeTableColumn = ({commit}, payload) => commit('REMOVE_TABLE_COLUMN', payload)

/** @function
 *  @actions for table component in Digital OM
 */
const uploadImage = ({commit}, payload) => new Promise((resolve, reject) => {
    http.post('dom/images/', payload.form)
        .then(res => {
            commit('IMAGE_UPLOAD_SUCCESS', {
                data: res.data,
                sectionIndex: payload.sectionIndex,
                pageIndex: payload.pageIndex,
                componentIndex: payload.componentIndex
            })
            resolve()
        })
        .catch(err => {
            commit('IMAGE_UPLOAD_FAILURE', err.response.data)
            reject(err)
        })
})

/** @function
 *  @actions for modal component in Digital OM
 */
const createComponent = ({ commit }, payload) => commit('CREATE_NEW_COMPONENT', payload)

const fetchDigitalOM = ({ commit, rootState, dispatch }, payload) => new Promise((resolve, reject) => {
    http.get(`projects/${rootState.route.params.projectId}/digital-om/`)
        .then(res => {
            commit('SETUP_DIGITAL_OM', {
                id: res.data.digital_om.id,
                address: res.data.digital_om.meta.address
            })
            commit('SET_DIGITAL_OM_META', res.data.digital_om.meta)
            commit('SET_WAR_ROOM_ID', res.data.digital_om.war_room)
            dispatch('getSections', res.data.digital_om.id)
                .then(res => {
                    var PromiseSections = []
                    res.data.data.forEach(section => {
                        PromiseSections.push(dispatch('getPages', section.id))
                    })
                    Promise.all(PromiseSections)
                        .then(sections => {
                            sections.forEach(section => {
                                section.data.data.forEach(page => {
                                    dispatch('getComponents', page.id)
                                })
                            })
                            resolve()
                        })
                })
        })
        .catch(e => reject(e))
})

const getPages = ({ commit, dispatch }, sectionId) => {
    return http.get(`dom/sections/${sectionId}/pages/`)
        .then((res) => {
            var pages = res.data.data
            dispatch('getSection', sectionId)
                .then(res => {
                    if (pages.length > 0) {
                        commit('GET_PAGES', { sectionIndex: res.data.order, data: pages })
                    } else {
                        commit('GET_PAGES', { sectionIndex: res.data.order, data: [] })
                    }
                })
            return res
        })
}

const getPage = ({ commit, dispatch }, pageId) => {
    return http.get(`dom/pages/${pageId}`)
        .then(res => {
            return res
        })
}

const getSections = ({ commit, dispatch }, id) => {
    return http.get(`dom/digital-oms/${id}/sections/`)
        .then(res => {
            if (res.data.data.length > 0) {
                commit('GET_SECTIONS', res.data.data)
            } else {
                commit('GET_SECTIONS', [])
            }
            return res
        })
        .catch(err => console.log(err))
}

const getSection = ({ commit, dispatch }, id) => {
    return http.get(`dom/sections/${id}`)
        .then(res => {
            return res
        })
        .catch(err => {
            Promise.reject(err)
        })
}

const createSection = ({ commit }, payload) => commit('CREATE_NEW_SECTION', payload)

const postSection = ({ commit, dispatch }, payload) => {
    if (payload.sectionId === null) {
        return http.post(`dom/digital-oms/${payload.domId}/sections/`, {
            title: payload.title,
            is_visible: payload.is_visible
        }).then(res => {
            commit('UPDATE_SECTION_ID', {
                sectionId: res.data.section_id,
                index: payload.index
            })
            commit('UPDATE_SECTION_TITLE', {
                sectionIndex: payload.index,
                value: payload.title
            })
        })
    } else {
        return dispatch('patchSection', {
            'sectionId': payload.sectionId,
            'title': payload.title
        })
        .then(res => {
            return Promise.resolve(payload.sectionId)
        })
    }
}

const patchSection = ({commit}, payload) => {
    return http.patch(`dom/sections/${payload.sectionId}/`, {
        'title': payload.title
    })
}

const deleteSection = ({ commit, dispatch }, payload) => {
    http.del(`dom/sections/${payload.sectionId}`)
        .then(res => {
            dispatch('removeSection', payload.sectionIndex)
        })
}

const removeSection = ({commit}, payload) => commit('REMOVE_SECTION', payload)

const createPage = ({ commit, state }, layout) => commit('CREATE_NEW_PAGE', layout)
const postPage = ({ commit, dispatch }, payload) => {
    if (payload.pageId === null) {
        return http.post(`dom/sections/${payload.sectionId}/pages/`, {
            layout: payload.layout.name,
            title: payload.title
        })
        .then(res => {
            dispatch('createPage', {
                layout: payload.layout,
                sectionIndex: payload.sectionIndex,
                pageId: res.data.page_id,
                title: payload.title
            })
            return res.data.page_id
        })
    } else {
        return dispatch('patchPage', {
            'pageId': payload.pageId,
            'layout': payload.layout,
            'title': ''
        })
        .then(res => {
            return payload.pageId
        })
    }
}

const removePage = ({ commit }, payload) => commit('REMOVE_PAGE', payload)

const deletePage = ({ commit, dispatch }, payload) => {
    return http.del(`dom/pages/${payload.pageId}`)
        .then(res => {
            dispatch('removePage', {
                sectionIndex: payload.sectionIndex,
                pageIndex: payload.pageIndex
            })
        })
}

const patchPage = ({commit, dispatch}, payload) => {
    return http.patch(`dom/pages/${payload.pageId}/`, {
        'layout': payload.layout,
        'title': payload.title
    })
    .then(() => {
        dispatch('updatePage', {
            'layout': payload.layout,
            'title': payload.title,
            'pageIndex': payload.pageIndex,
            'sectionIndex': payload.sectionIndex,
            'id': payload.pageId
        })
    })
}

const reorderPage = ({commit}, payload) => {
    return http.put(`dom/sections/${payload.sectionId}/re-order/`, {
        'ordering': payload.pages
    })
    .then(res => {
        return Promise.resolve(res.data)
    })
    .catch(e => {
        return Promise.reject(e)
    })
}

const getMap = ({ commit, dispatch }, payload) => {
    if (payload.componentId === null) {
        dispatch('postMap', {
            pageId: payload.pageId,
            pageIndex: payload.pageIndex,
            sectionIndex: payload.sectionIndex,
            componentIndex: payload.componentIndex,
            value: payload.value
        })
    } else {
        dispatch('patchMap', {
            pageId: payload.pageId,
            componentId: payload.componentId,
            componentIndex: payload.componentIndex,
            points: payload.value.points
        })
    }
}

const getText = ({ commit, dispatch }, payload) => {
    if (payload.componentId === null) {
        dispatch('postText', {
            pageId: payload.pageId,
            pageIndex: payload.pageIndex,
            sectionIndex: payload.sectionIndex,
            componentIndex: payload.componentIndex,
            value: payload.value
        })
    } else {
        dispatch('patchText', {
            pageId: payload.pageId,
            componentId: payload.componentId,
            componentIndex: payload.componentIndex,
            value: payload.value
        })
    }
}
const getImage = ({ commit, dispatch }, payload) => {
    if (payload.componentId === null) {
        dispatch('postImage', {
            pageId: payload.pageId,
            pageIndex: payload.pageIndex,
            sectionIndex: payload.sectionIndex,
            componentIndex: payload.componentIndex,
            value: payload.value
        })
    } else {
        dispatch('patchImage', {
            pageId: payload.pageId,
            componentId: payload.componentId,
            componentIndex: payload.componentIndex,
            value: payload.value
        })
    }
}

const getTable = ({ commit, dispatch }, payload) => {
    if (payload.componentId === null) {
        dispatch('postTable', {
            pageId: payload.pageId,
            pageIndex: payload.pageIndex,
            sectionIndex: payload.sectionIndex,
            componentIndex: payload.componentIndex,
            headers: payload.value.headers,
            rows: payload.value.rows
        })
    } else {
        dispatch('patchTable', {
            pageId: payload.pageId,
            componentId: payload.componentId,
            componentIndex: payload.componentIndex,
            headers: payload.value.headers,
            rows: payload.value.rows
        })
    }
}

const postTable = ({ commit }, payload) => {
    return http.post(`dom/pages/${payload.pageId}/components/table/`, {
        'position': payload.componentIndex,
        'value': {
            'title': null,
            'headers': payload.value.headers,
            'rows': payload.value.rows,
            'stylings': []
        }
    })
    .then(res => {
        commit('UPDATE_COMPONENT', {
            componentId: res.data.component_id,
            componentIndex: payload.componentIndex,
            sectionIndex: payload.sectionIndex,
            pageIndex: payload.pageIndex
        })
    })
    .catch(e => {
        console.log(e)
    })
}

const patchTable = ({commit}, payload) => {
    return http.patch(`dom/components/${payload.componentId}/`, {
        'position': payload.componentIndex,
        'value': {
            'title': null,
            'headers': payload.value.headers,
            'rows': payload.value.rows,
            'stylings': []
        },
        'stylings': []
    })
    .catch(e => console.log(e))
}

const postText = ({ commit }, payload) => {
    http.post(`dom/pages/${payload.pageId}/components/text/`, {
        'position': payload.componentIndex,
        'value': {
            'body': payload.value
        }
    })
    .then(res => {
        commit('UPDATE_COMPONENT', {
            componentId: res.data.component_id,
            componentIndex: payload.componentIndex,
            sectionIndex: payload.sectionIndex,
            pageIndex: payload.pageIndex
        })
    })
    .catch(e => console.log(e))
}

const patchText = ({commit}, payload) => {
    return http.patch(`dom/components/${payload.componentId}/`, {
        'value': {
            'body': payload.value
        }
    })
    .catch(e => {
    })
}

const postMap = ({ commit }, payload) => {
    http.post(`dom/pages/${payload.pageId}/components/map/`, {
        'position': payload.componentIndex,
        'value': {
            'points': payload.value
        }
    })
    .then(res => {
        commit('UPDATE_COMPONENT', {
            componentId: res.data.component_id,
            componentIndex: payload.componentIndex,
            sectionIndex: payload.sectionIndex,
            pageIndex: payload.pageIndex
        })
    })
    .catch(e => console.log(e))
}

const patchMap = ({commit}, payload) => {
    http.patch(`dom/components/${payload.componentId}/`, {
        'position': payload.componentIndex,
        'value': {
            'points': payload.value
        }
    })
    .catch(e => console.log(e))
}

const fetchImage = ({commit}, payload) => {
    return http.get(`dom/images/${payload.imageId}`)
           .then(res => {
               commit('LOAD_IMAGE', {
                   sectionIndex: payload.sectionIndex,
                   pageIndex: payload.pageIndex,
                   componentIndex: payload.componentIndex,
                   value: res.data.url
               })
           })
}

const postImage = ({ commit }, payload) => {
    return http.post(`dom/pages/${payload.pageId}/components/image/`, {
        'position': payload.componentIndex,
        'value': {
            'image_id': payload.value.image_id
        }
    })
    .then(res => {
        commit('UPDATE_COMPONENT', {
            componentId: res.data.component_id,
            componentIndex: payload.componentIndex,
            sectionIndex: payload.sectionIndex,
            pageIndex: payload.pageIndex
        })
    })
    .catch(e => console.log(e))
}

const patchImage = ({commit}, payload) => {
    return http.patch(`dom/components/${payload.componentId}/`, {
        'position': payload.componentIndex,
        'value': {
            'image_id': payload.value.image_id
        }
    })
    .then(res => {
        commit('UPDATE_COMPONENT', {
            componentId: res.data.component_id,
            componentIndex: payload.componentIndex,
            sectionIndex: payload.sectionIndex,
            pageIndex: payload.pageIndex
        })
    })
    .catch(e => console.log(e))
}

const getComponents = ({ commit, dispatch }, pageId) => {
    return http.get(`dom/pages/${pageId}/components/`)
        .then(res => {
            var components = res.data.data
            dispatch('getPage', pageId)
                .then(res => {
                    var pageIndex = res.data.order
                    dispatch('getSection', res.data.section)
                        .then(res => {
                            if (components.length > 0) {
                                commit('GET_COMPONENTS', {
                                    sectionIndex: res.data.order,
                                    pageIndex: pageIndex,
                                    data: components
                                })
                            } else {
                                commit('GET_COMPONENTS', {
                                    sectionIndex: res.data.order,
                                    pageIndex: pageIndex,
                                    data: []
                                })
                            }
                        })
                })
        })
}

const togglePanel = ({ commit }) => commit('TOGGLE_PANEL')

const setPageComponent = ({ commit }, payload) => commit('SET_PAGE_COMPONENT', payload)

const deleteComponent = ({ commit }, payload) => {
    if (payload.componentId === null) {
        commit('REMOVE_COMPONENT', payload)
    } else {
        return http.del(`dom/components/${payload.componentId}`)
            .then(res => {
                commit('REMOVE_COMPONENT', payload)
            })
    }
}

const updatePage = ({ commit }, payload) => commit('UPDATE_PAGE', payload)

const updateSectionTitle = ({ commit }, payload) => commit('UPDATE_SECTION_TITLE', payload)

const reorderPages = ({ commit, dispatch }, payload) => commit('REORDER_PAGES', payload)
const nestPage = ({ commit, dispatch }, payload) => commit('NEST_PAGE', payload)

const postGeneratedTable = ({ commit, dispatch }, payload) => new Promise((resolve, reject) => {
    http.post(`dom/pages/${payload.pageId}/components/generated-table/`, {
        position: payload.componentIndex,
        value: {
            key: payload.table,
            selected_options: {
                time_frames: [],
                columns: []
            },
            resource: 'project'
        }
    })
    .then(res => {
        commit('UPDATE_COMPONENT', {
            componentId: res.data.component_id,
            componentIndex: payload.componentIndex,
            sectionIndex: payload.sectionIndex,
            pageIndex: payload.pageIndex
        })
        dispatch('getGeneratedTable', res.data.component_id).then((data) => resolve(data))
    })
    .catch(err => reject(err))
})

const getGeneratedTable = ({ commit }, id) => new Promise((resolve, reject) => {
    http.get(`dom/components/${id}/`)
        .then(res => {
            let url = res.data.value.request_url.replace(/^\/+/g, '')
            http.get(url).then(r => resolve(r.data))
        })
        .catch(err => reject(err))
})

const updateGeneratedTable = ({ commit, dispatch }, payload) => new Promise((resolve, reject) => {
    http.patch(`dom/components/${payload.id}/`, payload.data)
        .then(() => {
            dispatch('getGeneratedTable', payload.id).then((data) => resolve(data))
        })
        .catch(err => reject(err))
})

/**
 * Toggle the primary navigation menu for the Digital OM
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
const toggleMenu = ({ commit }) => commit('TOGGLE_MENU')

/**
 * Reset the back to the original state
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
const resetState = ({ commit }) => commit('RESET_STATE')

/**
 * Set the target section ID and open the layout selection modal
 *
 * @param  {Function} options.commit
 * @param  {Number} id
 * @return {Void}
 */
const selectPageLayout = ({ commit }, payload) => {
    commit('SET_LAYOUT_SECTION', payload)
    commit('OPEN_LAYOUT_MODAL')
}

/**
 * Reset the page layout selection modal
 *
 * @param  {[type]} options.commit
 * @return {[type]}
 */
const closePageSelectionDialog = ({ commit }) => {
    commit('CLOSE_LAYOUT_MODAL')
    commit('SET_LAYOUT_SECTION', null)
}

const createInvisibleSectionWithPage = ({ commit, dispatch, state }, payload) => new Promise((resolve, reject) => {
    dispatch('createSection', {
        title: 'Invisible',
        data: [],
        visible: false
    })
    dispatch('postSection', {
        sectionId: null,
        domId: state.digitalOM.id,
        title: 'Invisible',
        index: state.digitalOM.sections.length - 1,
        is_visible: false
    })
    .then(res => {
        dispatch('postPage', {
            title: payload.title,
            sectionIndex: state.digitalOM.sections.length - 1,
            sectionId: state.digitalOM.sections[state.digitalOM.sections.length - 1].id,
            pageIndex: null,
            pageId: null,
            layout: payload.layout
        })
        resolve()
    })
})

/**
 * Toggle the edit mode for the Digital OM
 *
 * @param  {Function} options.commit
 * @param  {Boolean} value
 * @return {Promise}
 */
const toggleEditMode = ({ commit }) => commit('TOGGLE_EDIT_MODE')

export default {
    resetState,
    deletePage,
    removePage,
    removeSection,
    deleteSection,
    updatePage,
    updateSectionTitle,
    togglePanel,
    addPoint,
    removePoint,
    focusPoint,
    addText,
    deleteText,
    updateTableData,
    updateTableHeader,
    addTableRow,
    setPageComponent,
    deleteComponent,
    addTableColumn,
    removeTableRow,
    removeTableColumn,
    createPage,
    createSection,
    postSection,
    postPage,
    postTable,
    postText,
    postMap,
    fetchImage,
    postImage,
    patchSection,
    patchPage,
    patchTable,
    patchText,
    patchMap,
    patchImage,
    createComponent,
    getComponents,
    fetchDigitalOM,
    getSections,
    getSection,
    getPages,
    getPage,
    getTable,
    getMap,
    getImage,
    getText,
    uploadImage,
    reorderPage,
    reorderPages,
    nestPage,
    getGeneratedTable,
    postGeneratedTable,
    updateGeneratedTable,
    toggleMenu,
    selectPageLayout,
    closePageSelectionDialog,
    createInvisibleSectionWithPage,
    toggleEditMode
}



// WEBPACK FOOTER //
// ./src/state/modules/dom/actions.js